// extracted by mini-css-extract-plugin
export var aircallIframe = "_gj-3";
export var fabContainer = "_gj-5";
export var fabRinging = "_gj-6";
export var loadingOverlay = "_gj-4";
export var pulse = "_gj-7";
export var widgetContent = "_gj-2";
export var widgetPanel = "_gj-0";
export var widgetPanelExpanded = "_gj-1";